import { put, takeLatest, call } from 'redux-saga/effects';

import {
  getMyEventsSuccess,
  getAllEventsSuccess,
  getSingleEventSuccess,
  getOrgEventsSuccess,
  updateEventsSuccess,
} from '../actionCreators/events';
import {
  GET_MY_EVENTS_REQUEST,
  GET_EVENTS_REQUEST,
  GET_SINGLE_EVENT_REQUEST,
  EVENT_NOT_GOING_REQUEST,
  EVENT_GOING_REQUEST,
  GET_ORG_EVENTS_REQUEST,
  UPDATE_EVENT_REQUEST,
  GET_SINGLE_FEED_REQUEST,
  GET_SINGLE_EVENT_REQUEST_SUCCESS
} from '../constants/actionTypes';
import EventsApi from '../api/events';
import errorHandler from '../utils/requestErrorHandler';
import { addAlertToAlertsList } from '../actionCreators/globalAlerts';

function* getAllEventsRequest() {
  try {
    const data = yield call(EventsApi.getAllEvents);

    yield put(getAllEventsSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* getMyEventsRequest() {
  try {
    const data = yield call(EventsApi.getMyEvents);

    yield put(getMyEventsSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* getEventRequest(action) {
  try {
    const data = yield call(EventsApi.getSingleEvent, action);

    yield put(getSingleEventSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* eventGoingRequest(action) {
  try {
    yield call(EventsApi.eventGoing, action);

    const payload = {
      id: action.id,
    }

    const data = yield call(EventsApi.getSingleEvent, payload);

    yield put(getSingleEventSuccess(data));

  } catch (error) {
    yield errorHandler(error);
  }
}

function* eventNotGoingRequest(action) {
  try {
    yield call(EventsApi.eventNotGoing, action);

    const payload = {
      id: action.id,
    }

    const data = yield call(EventsApi.getSingleEvent, payload);

    yield put(getSingleEventSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* getOrgEvents(action) {
  try {
    const data = yield call(EventsApi.getOrgEvents, action.payload);

    yield put(getOrgEventsSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* updateEventRequest(action) {
  try {
    const data = yield call(EventsApi.updateEvent, action.payload);
    if (data.success) {
      yield put(updateEventsSuccess(data.event));
      yield put(
        addAlertToAlertsList({
          title: 'Event',
          message: 'Your event was updated successfully.',
          messageStyle: { color: '#505A62', textAlign: 'left', width: '100%' },
          confirmBtnText: 'OKAY',
          confirmBtnAction: action.payload.cb,
        }),
      );
    } else {
      yield put(
        addAlertToAlertsList({
          title: 'Community',
          message:
            data && data.message
              ? data.message
              : 'Unable to updated community. Please try again later.',
          messageStyle: { color: '#505A62', textAlign: 'left', width: '100%' },
          confirmBtnText: 'OKAY',
        }),
      );
    }
  } catch (error) {
    yield errorHandler(error);
  }
}

export default function* watchCategory() {
  yield takeLatest(GET_EVENTS_REQUEST, getAllEventsRequest);
  yield takeLatest(GET_MY_EVENTS_REQUEST, getMyEventsRequest);
  yield takeLatest(GET_SINGLE_EVENT_REQUEST, getEventRequest);
  yield takeLatest(EVENT_GOING_REQUEST, eventGoingRequest);
  yield takeLatest(EVENT_NOT_GOING_REQUEST, eventNotGoingRequest);
  yield takeLatest(GET_ORG_EVENTS_REQUEST, getOrgEvents);
  yield takeLatest(UPDATE_EVENT_REQUEST, updateEventRequest);
}
